export default {"src":"/_next/static/media/abt.23592239.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};